import React, { useState } from 'react';
import { Button, Col, Row, Card, Typography, Breadcrumb, Menu } from 'antd';
import UserManage from './UserManage';
import PublicationManage from './PublicationManage';
import AccessLogManage from './AccessLogManage';
import { SettingOutlined, UserOutlined, FileTextOutlined, HistoryOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function Manage() {

    const [selectedPage, setSelectedPage] = useState('UserManage');

    const menuItems = [
        {
            key: 'UserManage',
            icon: <UserOutlined />,
            label: 'User Management',
        },
        {
            key: 'PublicationManage',
            icon: <FileTextOutlined />,
            label: 'Publication Management',
        },
        {
            key: 'AccessLogManage',
            icon: <HistoryOutlined />,
            label: 'Access Logs',
        }
    ];

    const renderPage = () => {
        switch (selectedPage) {
            case 'UserManage':
                return (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '8px' }}>
                            <UserOutlined style={{ fontSize: '20px', color: '#055878' }} />
                            <Text style={{ fontSize: '18px', fontWeight: 700, color: '#055878' }}>Registered Users</Text>
                        </div>
                        <UserManage />
                    </>
                );
            case 'PublicationManage':
                return (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '8px' }}>
                            <FileTextOutlined style={{ fontSize: '20px', color: '#055878' }} />
                            <Text style={{ fontSize: '18px', fontWeight: 700, color: '#055878' }}>Publications</Text>
                        </div>
                        <PublicationManage />
                    </>
                );
            case 'AccessLogManage':
                return (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '8px' }}>
                            <HistoryOutlined style={{ fontSize: '20px', color: '#055878' }} />
                            <Text style={{ fontSize: '18px', fontWeight: 700, color: '#055878' }}>Access Logs</Text>
                        </div>
                        <AccessLogManage />
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div style={{ backgroundColor: '#f8fbff', minHeight: 'calc(100vh - 124px)', padding: '40px 24px' }}>
            <Row justify="center">
                <Col xs={24} lg={22}>
                    {/* Dashboard Header */}
                    <div style={{ marginBottom: '32px' }}>
                        <Breadcrumb items={[
                            { title: 'System' },
                            { title: <span style={{ color: '#055878', fontWeight: 600 }}>Administrative Console</span> }
                        ]} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', flexWrap: 'wrap', gap: '16px' }}>
                            <div>
                                <Title level={2} style={{ color: '#055878', margin: 0, fontWeight: 800 }}>
                                    Administrative Console
                                </Title>
                                <Text type="secondary">Review users, publications, access logs, and system settings.</Text>
                            </div>
                            <Button 
                                icon={<SettingOutlined />} 
                                size="large" 
                                style={{ borderRadius: '8px' }}
                            >
                                System Settings
                            </Button>
                        </div>
                    </div>

                    <Row gutter={[24, 24]}>
                        {/* Side Menu */}
                        <Col xs={24} md={6} lg={5}>
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                                    height: '100%'
                                }}
                                bodyStyle={{ padding: '16px 0' }}
                            >
                                <Menu
                                    mode="inline"
                                    selectedKeys={[selectedPage]}
                                    onClick={(e) => setSelectedPage(e.key)}
                                    items={menuItems}
                                    style={{ borderRight: 'none', fontSize: '15px' }}
                                />
                            </Card>
                        </Col>

                        {/* Main Content Card */}
                        <Col xs={24} md={18} lg={19}>
                            <Card 
                                bordered={false} 
                                style={{ 
                                    borderRadius: '16px', 
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                                    minHeight: '500px',
                                    overflow: 'hidden'
                                }}
                                bodyStyle={{ padding: '24px' }}
                            >
                                {renderPage()}
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}
